import { post } from '@rails/request.js';

import FormController from "@controllers/portal/components/form_controller";

export default class extends FormController {

  static targets = ['asIsSection', 'asIsInput'];
  static values = {
    applyBasePriceUrl: String,
  };

  connect() {
    // eslint-disable-next-line no-console
    console.log('Controller: Portal::Forms::BaseOption connected!');
    console.log(this.applyBasePriceUrlValue);
  }

  dropdownBlur(e) {

    const dropdown = e.detail.dropdown;

    if (dropdown.initializing || !e.detail.wasChanged) return;
    
    if (dropdown.id === 'base_option') {
      const selection = dropdown.getSelection() || '';
      if (selection.value === 'as-is') {
        this.asIsSectionTarget.classList.remove('hidden');
        this.asIsInputTarget.setAttribute('required', true);
        this.asIsInputTarget.focus();
      } else {
        this.asIsSectionTarget.classList.add('hidden');
        this.asIsInputTarget.removeAttribute('required');
        this.asIsInputTarget.value = '';
      }
    }
  }

  applyBasePrice(e) {
    e.preventDefault();
    const url = this.applyBasePriceUrlValue;
    const dropdown = this.getDropdownControllerById('base_option');
    const selection = dropdown.getSelection();

    if (!selection || !selection.value === '') {
      dropdown.validate();
      return;
    }

    const payload = {
      base_option: selection.value,
      as_is_price: this.asIsInputTarget?.value || null
    };

    if (selection.value === 'as-is') {
      const field = this.getInputControllerByName('as_is_price');
      if (!field?.validate()) {
        this.asIsInputTarget.focus();
        return;
      }
    }

    post(url, {
      body: JSON.stringify(payload),
      contentType: 'application/json',
      responseKind: 'turbo-stream',
    });
  }
}
